// Shared gift + t-shirt size option lists for address forms.
// Single source of truth — consumed by AddressForm and AddressBookPage
// (previously each rendered its own inline <option> list).

import type { SelectOption } from './regions';

export const GIFT_OPTIONS: SelectOption[] = [
  { value: '', label: 'Select Gift' },
  { value: 'Scale', label: 'Scale' },
  { value: 'Tshirt', label: 'Tshirt' },
  { value: 'Nutrafol', label: 'Nutrafol' },
];

export const TSHIRT_SIZES: SelectOption[] = [
  { value: '', label: 'Select Size' },
  { value: 'S', label: 'S' },
  { value: 'M', label: 'M' },
  { value: 'L', label: 'L' },
  { value: 'XL', label: 'XL' },
  { value: 'XXL', label: 'XXL' },
];
